module.exports = __webpack_public_path__ + "img/process-library-item.2d26c136.png";